const placeholders = {
  inquiry: '학습하는 분들께 도움이 되고, 더 좋은 답변을 드릴 수 있도록 질문전에 다음을 꼭 확인해주세요. \n\n'

    + '강의 내용과 관련된 질문을 남겨주세요.\n\n'

    + '[질문 내용]\n'
    + '여기에 질문 내용을 남겨주세요.',
};

export default placeholders;
